
      var _rect, _rect2, _path, _ellipse, _path2, _ellipse2, _path3, _ellipse3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmartMeterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 35.479,
  y: 29.053,
  width: 49.042,
  height: 64.262,
  rx: 4,
  stroke: "#000",
  strokeWidth: 4,
  strokeLinejoin: "round"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 42.792,
  y: 35.818,
  width: 34.416,
  height: 13.529,
  rx: 2,
  stroke: "#000",
  strokeWidth: 4,
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.959 58.58h5.801c.077 0 .13.078.107.157l-3.44 9.145a.113.113 0 0 0 .108.158h5.235c.092 0 .146.102.092.181L56.047 84.58c-.07.11-.237.032-.2-.094l3.54-12.456a.115.115 0 0 0-.107-.15h-5.19c-.077 0-.13-.079-.107-.158l4.876-13.07c.016-.048.062-.071.107-.071h-.007Z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "#810EA9",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.669,
  cy: 2.617,
  rx: 2.669,
  ry: 2.617,
  transform: "matrix(-1 0 0 1 46.655 106.766)",
  stroke: "#000",
  strokeWidth: 4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.986 93.316v13.449",
  stroke: "#000",
  strokeWidth: 4,
  strokeLinejoin: "round"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.669,
  cy: 2.586,
  rx: 2.669,
  ry: 2.586,
  transform: "matrix(-1 0 0 1 62.67 99.71)",
  stroke: "#000",
  strokeWidth: 4
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M60 93.316v6.034",
  stroke: "#000",
  strokeWidth: 4,
  strokeLinejoin: "round"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.669,
  cy: 2.617,
  rx: 2.669,
  ry: 2.617,
  transform: "matrix(-1 0 0 1 78.685 106.766)",
  stroke: "#000",
  strokeWidth: 4
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.015 93.316v13.086",
  stroke: "#000",
  strokeWidth: 4,
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M71 11s-4.388-4-11-4-11 4-11 4M66 16s-2.394-2-6-2-6 2-6 2",
  stroke: "#810EA9",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 21,
  r: 1.5,
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n<rect x=\"35.479\" y=\"29.0535\" width=\"49.0424\" height=\"64.2624\" rx=\"4\" stroke=\"black\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\r\n<rect x=\"42.7925\" y=\"35.8179\" width=\"34.4157\" height=\"13.5289\" rx=\"2\" stroke=\"black\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M58.9588 58.5796H64.7602C64.8366 58.5796 64.8901 58.6584 64.8672 58.7373L61.4276 67.8821C61.3971 67.961 61.4506 68.0398 61.5346 68.0398H66.7704C66.8621 68.0398 66.9156 68.1423 66.8621 68.2211L56.0466 84.5794C55.9778 84.6897 55.8097 84.6109 55.8479 84.4848L59.3868 72.0288C59.4098 71.9579 59.3563 71.8791 59.2798 71.8791H54.0899C54.0135 71.8791 53.96 71.8002 53.9829 71.7214L58.8594 58.6505C58.8747 58.6032 58.9206 58.5796 58.9664 58.5796H58.9588Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"#810EA9\" stroke-width=\"2.5\" stroke-linecap=\"round\"/>\r\n<ellipse cx=\"2.66915\" cy=\"2.61721\" rx=\"2.66915\" ry=\"2.61721\" transform=\"matrix(-1 -5.54042e-08 -5.58729e-08 1 46.6548 106.766)\" stroke=\"black\" stroke-width=\"4\"/>\r\n<path d=\"M43.9858 93.3159L43.9858 106.765\" stroke=\"black\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\r\n<ellipse cx=\"2.66915\" cy=\"2.58624\" rx=\"2.66915\" ry=\"2.58624\" transform=\"matrix(-1 -5.52659e-08 -5.60186e-08 1 62.6694 99.71)\" stroke=\"black\" stroke-width=\"4\"/>\r\n<path d=\"M60 93.3159L60 99.3505\" stroke=\"black\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\r\n<ellipse cx=\"2.66915\" cy=\"2.61721\" rx=\"2.66915\" ry=\"2.61721\" transform=\"matrix(-1 -5.54042e-08 -5.58729e-08 1 78.6846 106.766)\" stroke=\"black\" stroke-width=\"4\"/>\r\n<path d=\"M76.0151 93.3159L76.0151 106.402\" stroke=\"black\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\r\n<path d=\"M71 11C71 11 66.6116 7 60 7C53.3884 7 49 11 49 11\" stroke=\"#810EA9\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M66 16C66 16 63.6063 14 60 14C56.3937 14 54 16 54 16\" stroke=\"#810EA9\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"60\" cy=\"21\" r=\"1.5\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/smart-meter-icon.e5a03e2bb4befe77eb7cea55d709a9b7.svg"),
        {
          React: SvgSmartMeterIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      